import React from "react";
import "./Loader.css"; // Import the CSS for the loader animation

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
